import { H1 } from '@/components/Headings';
import { TextLarge } from '@/components/Texts';
import { Stack } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';

const AssetsHero = () => {
  const { t } = useTranslation('main');

  return (
    <Stack
      spacing={4}
      minH={'xs'}
      align={'center'}
      justify={'center'}
      textAlign={'center'}
      w='full'
    >
      <Stack color={'white'} w='full' maxW={620}>
        <H1>{t('assets.hero.heading')}</H1>
        <TextLarge>{t('assets.hero.description')}</TextLarge>
      </Stack>
    </Stack>
  );
};

export default AssetsHero;
